module.exports = (cookieName, domain = '') => {
    const domainString = domain !== '' ? ` domain=${domain};` : '';
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;${domainString}`;
};
